import {Trans} from '@common/i18n/trans';
import {Link} from '@app/dashboard/links/link';
import {useSettings} from '@common/core/settings/use-settings';
import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {ShareLinkButton} from '@app/dashboard/links/sharing/share-link-button';
import {Footer} from '@common/ui/footer/footer';
import {RedirectCountdownButton} from '@app/short-links/renderers/redirect-countdown-button';
import {Button} from '@common/ui/buttons/button';
import {AdHost} from '@common/admin/ads/ad-host';
import {Link as RouterLink} from 'react-router-dom';

interface LinkPageRendererProps {
  link: Link;
}
export function LinkSplashRenderer({link}: LinkPageRendererProps) {
  const {base_url} = useSettings();
  return (
    <div className="min-h-svh flex w-full flex-col bg-[#07070A] text-white">
      <Navbar
        menuPosition="link-page-navbar"
        rightChildren={<ShareLinkButton link={link} />}
        alwaysDarkMode
      />
      <div className="container mx-auto flex flex-auto flex-col items-center justify-center px-14 sm:px-24">
        <AdHost slot="splash_top" className="mb-60 mt-20 flex-shrink-0" />
        <div className="shorty-panel max-w-760 w-full flex-shrink-0 gap-24 p-20 md:flex">
          <img
            src={`${base_url}/${link.hash}/img`}
            alt=""
            className="h-240 w-320 max-w-full flex-shrink-0 rounded-lg border border-white/10 bg-white object-contain"
          />
          <div>
            <h1 className="mb-24 mt-24 text-2xl font-semibold md:mt-0">
              <Trans message="You are about to be redirected to another page." />
            </h1>
            <div className="flex flex-col gap-10 sm:flex-row">
              <RedirectCountdownButton
                variant="flat"
                color="primary"
                link={link}
              />
              <Button elementType={RouterLink} to="/">
                <Trans message="Go back" />
              </Button>
            </div>
            <div className="mt-24 border-t border-white/10 pt-24 text-sm leading-6 text-white/60">
              <Trans message="You are about to be redirected to another page. We are not responsible for the content of that page or the consequences it may have on you." />
            </div>
          </div>
        </div>
        <AdHost slot="splash_bottom" className="mb-20 mt-60 flex-shrink-0" />
      </div>
      <Footer className="px-24" />
    </div>
  );
}
